// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionInfoBlock__root--3izaV","title":"SubscriptionInfoBlock__title--1xEzH","info":"SubscriptionInfoBlock__info--UTD4b"};